import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import OutlinedButtonGroupVertSplit from "./OutlinedGroup/OutlinedButtonGroupVertSplit";
import OutlinedButtonGroupVertical from "./OutlinedGroup/OutlinedButtonGroupVertical";
import OutlinedButtonGroupHorzSplit from "./OutlinedGroup/OutlinedButtonGroupHorzSplit";
import OutlinedButtonGroupHorz from "./OutlinedGroup/OutlinedButtonGroupHorz";

const OutlinedButtonGroup = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Outlined Button Group
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          Button Group separated by outlined without background filled inside.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <OutlinedButtonGroupHorz />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonGroupHorzSplit />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonGroupVertical />
          </Grid>
          <Grid item xs={6}>
            <OutlinedButtonGroupVertSplit />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default OutlinedButtonGroup;
